import { KpiKey } from "./types";

const moneyFormatter = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  maximumFractionDigits: 0,
});

const numberFormatter = new Intl.NumberFormat("en-US");

export const formatMoney = (value: number): string =>
  moneyFormatter.format(value);

export const formatNumber = (value: number): string =>
  numberFormatter.format(value);

export const formatPercent = (value: number): string =>
  `${(value * 100).toFixed(1)}%`;

export function formatKpi(key: KpiKey, value: number): string {
  if (key === "revenue" || key === "cost" || key === "profit")
    return formatMoney(value);
  if (key === "margin") return formatPercent(value);
  return formatNumber(value);
}

export const formatDate = (date: Date | null): string =>
  date ? date.toLocaleDateString("en-GB") : "-";
